import React from "react";
import {
  FaLaptopCode,
  FaBrain,
  FaUniversity,
  FaIndustry,
  FaShoppingCart,
  FaCloud,
  FaCar,
  FaServer,
} from "react-icons/fa";

import "./Industry.css";

const industries = [
  {
    icon: <FaLaptopCode />,
    title: "Information Technology",
    desc: "Building high-performing software engineering teams for startups and enterprises.",
  },
  {
    icon: <FaBrain />,
    title: "Artificial Intelligence & Machine Learning",
    desc: "Connecting organizations with AI, ML, and Data Science professionals.",
  },
  {
    icon: <FaUniversity />,
    title: "Banking & Financial Services",
    desc: "Supporting financial institutions with secure and compliant technology talent.",
  },
  {
    icon: <FaIndustry />,
    title: "Manufacturing",
    desc: "Providing professionals for automation, Industry 4.0, and digital transformation.",
  },
  {
    icon: <FaShoppingCart />,
    title: "Retail & E-commerce",
    desc: "Helping businesses scale digital commerce with experienced technology teams.",
  },
  {
    icon: <FaCloud />,
    title: "SaaS & Product Development",
    desc: "Delivering engineers for cloud-native applications and scalable SaaS platforms.",
  },
  {
    icon: <FaServer />,
    title: "SAP",
    desc: "Providing skilled SAP consultants for implementation, integration, migration, and support.",
  },
  {
    icon: <FaCar />,
    title: "Automotive & Embedded",
    desc: "Connecting businesses with automotive software, embedded systems, and mobility specialists.",
  },
];

export default function Industries() {
  return (
    <section className="industries-section" id="industry">
      <div className="container">

        <span className="section-tag">
          INDUSTRIES WE SERVE
        </span>

        <h2>
          Powering Growth Across
          <span> Diverse Industries</span>
        </h2>

        <p className="section-subtitle">
          We deliver specialized IT staffing solutions across multiple
          industries, helping organizations build innovative and
          future-ready technology teams.
        </p>

        <div className="industry-grid">

          {industries.map((item, index) => (
            <div className="industry-card" key={index}>

              <div className="industry-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

              <span className="card-number">
                {String(index + 1).padStart(2, "0")}
              </span>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}
